/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.

  // Get permission and clearCart for web
  (function getPermissionAndClearCartForWeb() {

    // Clear cart
    window.addEventListener('message', event => {

      // Close shopify window on refresh from parent app (checkout issue fix)
      console.log('Received message event for clear cart ---> new',event);
      if (event && event.data) {
        if (event.data.action === "windowReloadTriggeredFromParentApp") {
          console.log('Reloading window as triggered from parent app tab remove');
          
          // CLEAR both values
          localStorage.removeItem('tabID');
          window.name = '';   // <-- VERY IMPORTANT

          // Clear cart
          clearCart({force: true});
          // Optional: force reload child to reset environment
          // window.location.reload();
        }
      }

      // console.log('event.origin', event.origin);
      console.log('event', event);

      // Temp
      // if (event.origin == null || !event.origin.endsWith('.zenda.com'))
        // return;

      // Clear cart
      if ((typeof event.data == 'object') && ('action' in event.data) && event.data.action == 'grantedPermissionToClearCart')
        clearCart({force: true});
      
    }, false);

    // Get permission to clearCart
    document.addEventListener("DOMContentLoaded", function() {
      if (!window.opener) return;
      window.opener.postMessage({action: 'getPermissionToClearCart', url: window.location.href}, '*');
    });
  })();

  // Clear cart on home page or first landing page when click on widget of zenda application.
  clearCartOnHomePage();
})();


// CUSTOM CODE BY ZENDA

var messageTriggeredClose = false;

/**
 * Post message to parent window / Mobile app
 * @param {{ref: string, [key: string]: any}} messageObj 
 */
function messageCaller(messageObj){


  messageTriggeredClose = true;
  var stringifiedMessageObj = JSON.stringify(messageObj);

    // Clear cart on zendaClose
    if (messageObj.ref == 'zendaClose') {
      clearCart({force: true, dontReloadPage: true});
    }

  if(messageObj.ref == 'zendaClose' || messageObj.ref == 'zendaPayment'){
    if(localStorage.tabID == window.name){
      localStorage.removeItem('tabID');           
    } else {
      window.name = '';
    }
  }

  try {
    // console.log(webkit)
    if (window.webkit && window.webkit.messageHandlers) {
      window.webkit.messageHandlers.cordova_iab.postMessage(stringifiedMessageObj);
    }
    // Capacitor IAB
    if (window.mobileApp && window.mobileApp.postMessage) {
      window.mobileApp.postMessage(stringifiedMessageObj);
    }
  } catch (error) {
    console.log({catch: 'zenda-message-caller-error', error});
  }

  try {
    if (window.opener)
      window.opener.postMessage(messageObj, "*");
  } catch (error) {
    console.log({catch: 'zenda-message-caller-error', error});
  }
}

// Detect Landing Page URL
console.log("document.referrer", document.referrer);

let referrerIsZenda = false;
try {
  referrerIsZenda = !!document.referrer && (new URL(document.referrer)).hostname.endsWith('.zenda.com');
} catch (e) { /* non-URL referrer */ }

if ((document.referrer == "" || document.referrer.endsWith('/shopify/verify') || referrerIsZenda) && window.location.pathname != "/cart") {
  localStorage['homeURL'] = window.location.href;
  console.log('homeURL set', localStorage['homeURL']);
}

// Prevent navigation from logo
if (document.querySelector("a.header__logo__link")) {
  document.querySelector("a.header__logo__link").addEventListener("click", async _ => {
      _.preventDefault();
      _.stopPropagation();
      _.stopImmediatePropagation();
  });
}

// Prevent navigation from shopify home page
let homePageProductBtn = document.querySelector(".hero__content .btn")
if(homePageProductBtn){
  homePageProductBtn.addEventListener("click", async _ => {
    _.preventDefault();
    _.stopPropagation();
    _.stopImmediatePropagation();
    if(localStorage['homeURL'] && (localStorage['homeURL'] != window.location.href)){
      window.location = localStorage['homeURL'];
    } else {
      history.back();
    }  
  });
}

// Close Button
document.querySelectorAll(".navlink.navlink--cart").forEach(async function (cart) {
  const closeBtn = document.createElement("div");
  closeBtn.setAttribute("class", "close-btn");
  closeBtn.innerHTML = '<svg width="20" height="20" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg"> <circle cx="12.5" cy="12.5" r="12.5" fill="rgba(236, 86, 150,0.8)"/> <path d="M16.4781 8.37553C16.7167 8.49239 16.9407 8.79914 16.9894 9.07668C17.0137 9.17893 16.9943 9.34448 16.9504 9.5003C16.8823 9.73402 16.7752 9.85574 15.4361 11.1899L13.9997 12.6263L15.4069 14.0383C16.1811 14.8125 16.8482 15.5185 16.8871 15.5965C17.1355 16.0882 16.9456 16.6725 16.4635 16.9209C16.259 17.028 15.8208 17.0231 15.6066 16.9111C15.514 16.8624 14.7983 16.1954 14.0241 15.4212L12.6072 14.014L11.2243 15.4066C10.4355 16.1954 9.75386 16.8381 9.64187 16.8965C9.22799 17.1156 8.66804 16.9744 8.41485 16.5898C8.24443 16.3317 8.20548 15.9081 8.3272 15.6646C8.37103 15.5721 9.04784 14.8563 9.8269 14.0773L11.2487 12.6506L9.8269 11.224C8.89689 10.294 8.3759 9.73888 8.3272 9.62203C7.99123 8.81375 8.81412 7.99573 9.59318 8.36092C9.71978 8.41935 10.2797 8.94522 11.1756 9.84601C11.9401 10.6105 12.5828 11.2386 12.612 11.2386C12.6364 11.2386 13.2937 10.6056 14.0728 9.82653C15.0077 8.89652 15.5481 8.395 15.665 8.34144C15.9182 8.23919 16.2249 8.24893 16.4781 8.37553Z" fill="#fff"/> </svg>';
  closeBtn.addEventListener("click", async _ => {
      _.preventDefault();
      _.stopPropagation();
      _.stopImmediatePropagation();

      debugTrace({action: 'zenda-close-listener', message: 'Zenda close listener added'});

      // old url flow
      // window.location.href = encodeURI(window.location.origin + "/zendaClose");  

      const data = await fetch('/cart.json');
      let cart = await data.json(); 

      // const data2 = await fetch('/cart.json');
      // let responseText = await data2.text();
      // cart.responseText = responseText;
      // remove product_description key
      console.log('cart console 1', cart);
      // cart = updateCartData(cart);
      
      var messageObj = { ref: "zendaClose", cart: cart };

    console.log('cart console', cart);
      messageCaller(messageObj);
    
    });
  cart.parentElement.parentElement.appendChild(closeBtn);
});


function consoleCheckFuction() {
  let consoleMethods = ["log", "error", "warn", "info"];
  // Store original console methods
  let originalConsoleLog = console.log;
  let originalConsoleError = console.error;
  let originalConsoleWarn = console.warn;
  let originalConsoleInfo = console.info;
  consoleMethods.forEach((method) => {
    console[method] = function (...args) {
      let consoleData = {
        data:{
            type: method.toString(),
            logData:args[0],
            args: args,
            location: window.location.href
           },
        ref: "consoleData"
      }
      messageCallerForDataDogConsole(consoleData);
      switch (method) {
        case 'info':
          originalConsoleInfo.apply(console, args);
          break;
        case 'warn':
          originalConsoleWarn.apply(console, args);
          break;
        case 'error':
          originalConsoleError.apply(console, args);
          break;
        default:
          originalConsoleLog.apply(console, args);
          break;
      }
    };
  });
}

function messageCallerForDataDogConsole(messageObj){
  messageTriggeredClose = true;
  var stringifiedMessageObj = JSON.stringify(messageObj);
  try {
    if (window.webkit && window.webkit.messageHandlers) {
      window.webkit.messageHandlers.cordova_iab.postMessage(stringifiedMessageObj);
    }
    // Capacitor IAB
    if (window.mobileApp && window.mobileApp.postMessage) {
      window.mobileApp.postMessage(stringifiedMessageObj);
    }
  } catch (error) {
  }

  try {
    if (window.opener)
      window.opener.postMessage(messageObj, "*");
  } catch (error) {
  }
}

//log track - data-dog - end

// Back Button
const backBtn = document.createElement("div");
backBtn.setAttribute("class", "close-btn");
backBtn.innerHTML = '<svg width="20" height="15" viewBox="0 0 10 13" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M6.82262 0.213037C6.70678 0.0818993 6.54737 0.005404 6.37923 0.000275472C6.21109 -0.00485306 6.0479 0.0618018 5.92534 0.185668L0.198067 6.00146C0.135489 6.06538 0.08566 6.14232 0.0516094 6.22759C0.0175587 6.31287 0 6.40471 0 6.49751C0 6.59031 0.0175587 6.68215 0.0516094 6.76743C0.08566 6.8527 0.135489 6.92964 0.198067 6.99356L5.92534 12.8094C6.0479 12.9332 6.21109 12.9999 6.37923 12.9947C6.54737 12.9896 6.70678 12.9131 6.82262 12.782C6.93782 12.6502 6.99981 12.4747 6.99504 12.294C6.99027 12.1132 6.91912 11.9418 6.79716 11.8172L1.55989 6.49751L6.79716 1.17777C6.91912 1.05323 6.99027 0.881833 6.99504 0.701052C6.99981 0.520271 6.93782 0.344814 6.82262 0.213037Z" fill="rgb(236, 86, 150)"/> </svg> ';
backBtn.addEventListener("click", async _ => {
    _.preventDefault();
    _.stopPropagation();
    _.stopImmediatePropagation();

    debugTrace({action: 'zenda-back-listener', message: 'Zenda back listener added'});
    
    // console.log('message-event document referer', document.referrer);
    if ((document.referrer == "" || document.referrer.endsWith('/shopify/verify'))) {
      if(window.location.pathname == "/cart") {
        // console.log('message-event homeurl', localStorage['homeURL']);
        window.location = localStorage['homeURL'];
      } 
      else {
        // old url flow
        // window.location.href = encodeURI(window.location.origin + "/zendaClose");
        var messageObj = { ref: "zendaClose" };
        messageCaller(messageObj);
      } 
    }
    else {
      // console.log('message-event document history back', history.back());
      if (history.length == 1) {
        // Temp
        // window.location = localStorage["homeURL"];
        var messageObj = { ref: "zendaClose" };
        messageCaller(messageObj);
      }
      else history.back();
    }
  });
if(screen.width < 479){
  document.querySelector("button.header__mobile__hamburger").parentElement.appendChild(backBtn); 
} else {
  if (document.querySelector("nav.header__menu")) {
    document.querySelector("nav.header__menu").parentElement.appendChild(backBtn); 
  }
}


// Home Button
const homeBtn = document.createElement("div");
homeBtn.setAttribute("class", "close-btn");
homeBtn.innerHTML = '<svg width="20" height="20" viewBox="0 0 20 20"> <path d="M3 10v11h6v-7h6v7h6v-11L12,3z" fill="rgba(236, 86, 150, 0.8)"/> </svg> ';
homeBtn.addEventListener("click", async _ => {
    _.preventDefault();
    _.stopPropagation();
    _.stopImmediatePropagation();

    debugTrace({action: 'zenda-home-btn-listener', message: 'Zenda home listener added'});

    if(localStorage['homeURL'] && (localStorage['homeURL'] != window.location.href)){
      window.location = localStorage['homeURL'];
    }
  
  });
if(screen.width < 479){
  document.querySelector("button.header__mobile__hamburger").parentElement.appendChild(homeBtn); 
} else {
  if (document.querySelector("nav.header__menu")) {
    document.querySelector("nav.header__menu").parentElement.appendChild(homeBtn); 
  }
}

// Handle page restore
window.addEventListener( "pageshow", async function ( event ) {
  var historyTraversal = 
        event.persisted || 
        ( typeof window.performance != "undefined" && 
          window.performance.navigation.type === 2 
        );

  if ( historyTraversal ) {
    
    // Bug fix: fetch cart.js instead of cart.json to avoid item_count mismatch
    // const data = await fetch('/cart.json');
    const data = await fetch('/cart.js');
    const cart = await data.json(); 
    document.documentElement.dispatchEvent(new CustomEvent('theme:cart:change', { 
      bubbles: !0, detail: { cartCount: cart.item_count } 
    }));
    
    const htmlData = await fetch(theme.routes.cart_url + '?section_id=api-cart-items');
    const cartHTML = await htmlData.text();                  
    const newCartContainer = document.createElement('div');
    newCartContainer.innerHTML = cartHTML;
    const newCart = newCartContainer.querySelector(['[data-api-content]']);
    window.cart.build(newCart);
    window.cart.closeCartDrawer();
    
  }
});

// Detect navigation to external URL
document.querySelectorAll(".external-url").forEach(function (link) {
  link.addEventListener("click", async _ => {
      _.preventDefault();
      _.stopPropagation();
      _.stopImmediatePropagation();

      debugTrace({action: 'zenda-external-url-listener', message: 'Zenda external url listener added'});

      // old url flow
      // window.location.href = encodeURI(window.location.origin + "/zendaOpen?url=" + _.target.href + "&history=" + window.location.href);

      // ZIP-5373: take the href from the bound anchor, not from _.target. Vendor (Webkul)
      // descriptions wrap link text in <span>/<strong>, so _.target can be a child with
      // no href and the app then opened `undefined` (black screen). Never post zendaOpen
      // without a url. Details: docs/tasks/ZIP-5373-waiver-link-not-opening-in-app/task.md
      var url = link.href;
      if (!url) {
        debugTrace({action: 'zenda-external-url-missing-href', message: 'external-url click without href, zendaOpen not sent', target: link.outerHTML});
        return;
      }

      var messageObj = {ref: 'zendaOpen'};
      messageObj.history = window.location.href;
      messageObj.url = url;
      messageCaller(messageObj);
      
  });
});

// Detect and trigger PDF download
document.querySelectorAll("#wk-esign-preview-doc").forEach(function (link) {
  link.addEventListener("click", async _ => {
    
    _.preventDefault();
    _.stopPropagation();
    _.stopImmediatePropagation();

    debugTrace({action: 'zenda-wk-esign-preview-listener', message: 'Zenda webkul esign preview listener added'});
    
    var message = _.target.href;
    var messageObj = {url: message, ref: 'downloadUrl'};
    messageCaller(messageObj);
    
  })
});

document.body.addEventListener('docapp-shipping-rate-chosen', function(buttonevent) {

    if(buttonevent && buttonevent.payload && buttonevent.payload.estTotal) 
      sessionStorage.setItem("totalCartAmount", buttonevent.payload.estTotal); 
  
    if(buttonevent && buttonevent.payload && buttonevent.payload.rateAmount) 
      sessionStorage.setItem("shippingPrice", buttonevent.payload.rateAmount); 

    console.log('document.querySelector(".docapp-shipping-calculator--input-city")', document.querySelector(".docapp-shipping-calculator--input-city"));
    if (document.querySelector(".docapp-shipping-calculator--input-city"))    
      sessionStorage.setItem("shippingCalculatorAddress", document.querySelector(".docapp-shipping-calculator--input-city").value); 

    if (document.querySelector(".docapp-shipping-calculator--input-zip"))
      sessionStorage.setItem("shippingCalculatorZip", document.querySelector(".docapp-shipping-calculator--input-zip").value); 
    
    const countryElement = document.querySelector("select[name='shipping_address[country]']");
  
    if(countryElement){
        const countrySelected = countryElement.options[countryElement.selectedIndex];
        if(countrySelected){
          const countryLabel = countrySelected.textContent;
          sessionStorage.setItem("shippingCalculatorCountry", countryLabel);
        }
  
    }
    // sessionStorage.setItem("shippingCalculatorCountry", document.querySelector("select[name='shipping_address[country]']").value)
    // sessionStorage.setItem("shippingCalculatorProvince", document.querySelector("select[name='shipping_address[province]']").value)
  
  
    const provinceElement = document.querySelector("select[name='shipping_address[province]']");
  
    if(provinceElement){
        const provinceSeleted = provinceElement.options[provinceElement.selectedIndex];
        if(provinceSeleted){
          const provinceLabel = provinceSeleted.textContent;
          sessionStorage.setItem("shippingCalculatorProvince", provinceLabel);
        }
    }
  
    // shipping rate calculation
    const shippingRateElements = document.querySelectorAll('.docapp-shipping-rate');
  
    shippingRateElements.forEach(divElement => {
      const radioInput = divElement.querySelector('input[type="radio"]:checked');
  
      if (radioInput) {
        sessionStorage.setItem("shippingModeName", radioInput.parentElement.textContent.trim());
          
      }
    });
  
    // change size of total
    const totalEstElement = document.querySelector(".docapp-cart-item.docapp-est-total.docapp-perm");
    if(totalEstElement){
      const  estLabel = totalEstElement.querySelector('.docapp-left');
      if(estLabel) estLabel.style.setProperty('font-size', '16px', 'important');
    
      const  estValue = totalEstElement.querySelector('.docapp-right')
      if(estValue) estValue.style.setProperty('font-size', '20px', 'important');
    }
  
  });


// Perform Checkout
async function doZendaCheckout(event) {
      debugTrace({ action: 'zendaPayment-doZendaCheckout', message: 'Zenda checkout initiated' });
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      const data = await fetch('/cart.json');
      let cart = await data.json(); 
      // const data2 = await fetch('/cart.json');
      // let responseText = await data2.text();
      // cart.responseText = responseText;
      // remove product_description key
      
      cart = updateCartData(cart);

      // Prevent checkout if the shipping details are not valid
      if (!cart) return;

      debugTrace({ action: 'zendaPayment-init', message: 'Zenda payment initiated', cart });

      var messageObj = {ref: 'zendaPayment'};
      messageObj.cart = cart;
      messageCaller(messageObj);

      debugTrace({ action: 'zendaPayment-transfer', message: 'Zenda payment transfered to zenda app' });
}

function updateCartData(cart) {
  cart.items = cart.items.map((item)=>{
        delete item.product_description;
        return item;
      })

      
       console.log(sessionStorage["shippingCalculatorAddress"], sessionStorage["shippingCalculatorZip"]);
  
      
        // == (document.querySelector(".docapp-cart-shipping.docapp-zip-label").innerText.replace(",","").trim())
        cart.items.forEach(function (item) {
          if(!item["properties"])
           item["properties"] = []; 
          if(sessionStorage["shippingCalculatorAddress"]) item["properties"]["Address"] = sessionStorage["shippingCalculatorAddress"];
          if(sessionStorage["shippingCalculatorZip"]) item["properties"]["Zip Code"] = sessionStorage["shippingCalculatorZip"];
          if(sessionStorage["shippingCalculatorCountry"]) item["properties"]["Country"] = sessionStorage["shippingCalculatorCountry"];
          if(sessionStorage["shippingCalculatorProvince"]) item["properties"]["Province"] = sessionStorage["shippingCalculatorProvince"];
          if(sessionStorage["shippingModeName"]) item["properties"]["ShippingOption"] = sessionStorage["shippingModeName"];
          if(sessionStorage["shippingPrice"]) item["properties"]["ShippingPrice"] = sessionStorage["shippingPrice"];
       });

      const totalEstElement = document.querySelector(".docapp-cart-item.docapp-cart-shipping");
      if(totalEstElement && totalEstElement.innerHTML.trim() != ''){
        // console.log('it exists');
        // console.log(sessionStorage["shippingCalculatorCountry"] ,  !sessionStorage["shippingCalculatorAddress"]); //sessionStorage["shippingCalculatorZip"] ,
        if(!sessionStorage["shippingCalculatorCountry"] &&  !sessionStorage["shippingCalculatorAddress"]){  // !sessionStorage["shippingCalculatorZip"] &&
          // console.log('problem here');

          totalEstElement.scrollIntoView({ behavior: 'smooth' });

          // Create a new element for the text
          const textElement = document.createElement('div');
          textElement.textContent = 'Please fill entire address';
          textElement.style.color = 'red'; // Set text color
          textElement.style.marginTop = '5px'; // Add some space below the div
          totalEstElement.appendChild(textElement);
          // After 5 seconds, remove the red text
          setTimeout(() => {
              totalEstElement.removeChild(textElement);
          }, 5000);
          
          // Return undefined to prevent checkout if the shipping details are not valid
          debugTrace({ action: 'zendaPayment-checkout-error', message: 'Please fill entire address' });
          return;
        }
      }
  
      console.log(cart);   
      // window.location.href = (window.location.origin + "/zendaPayment?cart=" + encodeURIComponent(JSON.stringify(cart)));

      // window.location.href = (window.location.origin + "/zendaPayment?cart=" + encodeURIComponent(JSON.stringify(cart)));

      cart.responseText = JSON.stringify(cart);
      console.log(cart);  
  return cart;
}

// Attach event listeners to checkout buttons
document.querySelectorAll("button.cart__checkout").forEach(function (checkout) {
  debugTrace({action: 'zenda-checkout-listener-on-cart-button', message: 'Zenda checkout listener added'});
  checkout.addEventListener("click", doZendaCheckout);
});


// Single-tab guard (desktop web only): newest tab wins.
// The tab that loads the store last always takes the lock; any other tab
// holding it is told through the 'storage' event and sends itself to the
// error page. A "first tab wins" lock cannot survive Back + reopen from the
// Zenda widget, because the first popup stays open. See K12PAPP-6023.
const TAB_LOCK_KEY = 'tabID';
const TAB_LOCK_ERROR_PATH = '/pages/opened-in-other-tab-error-page';

function tabLockEnabled() {
  return screen.width > 1024
    && location.host == 'zenda-dev-store.myshopify.com'
    && !location.href.includes('opened-in-other-tab-error-page');
}

// Always take the lock, even when another tab holds it (newest tab wins).
function claimTabLock() {
  if (!tabLockEnabled()) return;
  if (!window.name) window.name = Date.now();
  localStorage.setItem(TAB_LOCK_KEY, window.name);
  console.log('tabID claimed', localStorage.getItem(TAB_LOCK_KEY), 'window.name', window.name);
}

// Release only when this tab owns the lock. If another tab owns it, drop this
// tab's identity so its next load starts fresh. Safe to call more than once.
function releaseTabLock() {
  const owner = localStorage.getItem(TAB_LOCK_KEY);
  if (owner == window.name) {
    localStorage.removeItem(TAB_LOCK_KEY);
  } else if (owner) {
    window.name = '';
  }
}

// After window load
window.addEventListener("load", (event) => {

    if (screen.width > 1024) {

      console.log("tabID", localStorage.getItem('tabID'), "window.name", window.name, location);

      // Issue: The another tab opened error page prevent Admin Theme customization
      // Soln: Prevent the tab opened error page for Admin Theme customization
      if (location.host != 'zenda-dev-store.myshopify.com')
        return;

      claimTabLock();

    }
  
  // Play BG video on iOS
  setTimeout(function(){
    function iOS() {
      return [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod'
      ].includes(navigator.platform)
      // iPad on iOS 13 detection
      || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    }
    const videoEl = document.querySelector(".video-background video");
    if(videoEl){
      videoEl.setAttribute("playsinline", true);
      videoEl.setAttribute("webkit-playsinline", true);
      videoEl.playsInline = true;
      document.querySelector(".video-background video").preload="auto";

      if (iOS()) {
        videoEl.play();
        videoEl.removeAttribute('poster');
      }
    }
  });

  
  // CHECKOUT TEMP FIX

  var target = document.getElementsByClassName('cart__foot__inner');
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type == "childList") {
        document.querySelectorAll("a.cart__checkout").forEach(function (checkout) {
          debugTrace({action: 'zenda-checkout-listener-in-cart-footer', message: 'Zenda checkout listener added', el: checkout});
          checkout.addEventListener("click", doZendaCheckout);
        });
      }
    });
  });
  if(target[0])
    observer.observe(target[0], { childList: true });

  // END OF TEMP FIX
  
  // to update home url in local storage
    const searchParams = new URLSearchParams(window.location.search);
    console.log(searchParams);

    if (searchParams.get("homeUrl")) {
      localStorage.setItem("homeURL", searchParams.get("homeUrl"));
    }

  // to clear cart data
    const logData = {action: 'zenda-clear-cart', message: 'Zenda clear cart check', pathname: window.location.pathname, referrer: document.referrer, historyLength: history.length, shouldClearCart: !(window.location.pathname).includes('/cart') && ((document.referrer == "" || document.referrer.endsWith('/shopify/verify')) || history.length == 1)};
    debugTrace(logData);
    console.log('zenda-clear-cart-log', logData);
    // alert('zenda-clear-cart-log: ' + JSON.stringify(logData));
    // console.log('zenda-clear-cart-initiate', {notIncludes: !(window.location.pathname).includes('/cart'), referrer: document.referrer, endsWith: document.referrer.endsWith('/shopify/verify'), historyLength: history.length, cdn: (!(window.location.pathname).includes('/cart') &&((document.referrer == "" || document.referrer.endsWith('/shopify/verify')) || history.length == 1)), newCdn: (!(window.location.pathname).includes('/cart') &&(((document.referrer == "" && history.length == 1) || document.referrer.endsWith('/shopify/verify')) || history.length == 1))});

    /*
    // Clear cart after landing to home page (at first time) when click on widget of zenda application. Permanantly Hide the cart count for landing page, because its initial page then how an user can add any iterm to cart.
    if (
      !(window.location.pathname).includes('/cart') &&
      (((document.referrer == "" && history.length == 1) || document.referrer.endsWith('/shopify/verify')) || history.length == 1)
    ) {
      clearCart({dontReloadPage: true});
    } else {
      // Hide the cart count intially as it keeps event click on second widget. And Show the cart count for second page onward (even home page if redirect from inside the shopify)
      setTimeout(() => {
        const els = document.querySelectorAll('.header__cart__status');
        els.forEach(el => el.removeAttribute('style'));
      }, 0);
    }
    */

    // if((document.referrer == "" || document.referrer.endsWith('/shopify/verify')) || history.length == 1){
    //   if ((window.location.pathname).includes('/cart')){
    //     localStorage.setItem('editCartFlow', true)
    //   }
    //   else localStorage.setItem('editCartFlow', false);
    // }


  //log track - data-dog - strat
  consoleCheckFuction();
    
});

/**
 * Is this page the first page of a widget visit (entered from the Zenda app, not from inside the store)?
 *
 * ZIP-5478: the old check relied on history.length == 1, which a fresh in-app browser does not
 * always have on its first page, so a cart left over from one widget was checked out under the
 * next widget's category. Widget opens load the widget URL directly, so a landing has no referrer
 * (or one from another host); every in-store navigation carries the store's own referrer.
 * The cart page is never a landing. Details: docs/tasks/ZIP-5478-hvp-instead-of-lvp-channel/task.md.
 *
 * @returns {boolean}
 */
function isWidgetLanding() {
  if ((window.location.pathname).includes('/cart')) return false;
  if (!document.referrer) return true;
  try {
    return (new URL(document.referrer)).hostname != window.location.hostname;
  } catch (e) {
    return true; // non-URL referrer: not the store
  }
}

/**
 * Clear cart on home page or first landing page when click on widget of zenda application.
 *
 * @description Clear cart after landing to home page (at first time) when click on widget of zenda application. Permanantly Hide the cart count for landing page, because its initial page then how an user can add any iterm to cart. Else, Hide the cart count intially as it keeps event click on second widget. And Show the cart count for second page onward (even home page if redirect from inside the shopify)
 * @returns {void}
 */
function clearCartOnHomePage() {

  // Clear cart after landing to home page (at first time) when click on widget of zenda application. Permanantly Hide the cart count for landing page, because its initial page then how an user can add any iterm to cart.
  const landing = isWidgetLanding();

  // ZIP-5478: trace the decision; the clear below must not depend on this trace (the app bridge may not be attached yet).
  debugTrace({action: 'zenda-landing-check', message: 'Widget landing check', referrer: document.referrer, historyLength: history.length, pathname: window.location.pathname, cleared: landing});

  if (landing) {
    clearCart({force: true, dontReloadPage: true});
  } else {
    // Hide the cart count intially as it keeps event click on second widget. And Show the cart count for second page onward (even home page if redirect from inside the shopify)
    setTimeout(() => {
      const els = document.querySelectorAll('.header__cart__status');
      els.forEach(el => el.removeAttribute('style'));
    }, 0);
  }
}

// Leaving the page (navigation, close, bfcache entry): release the lock.
window.addEventListener("beforeunload", releaseTabLock);
window.addEventListener("pagehide", releaseTabLock);

// Another tab took the lock: this tab is no longer the live one.
// 'storage' fires only in other tabs, never in the one that wrote the key.
window.addEventListener("storage", (event) => {
  if (event.key != TAB_LOCK_KEY || !tabLockEnabled()) return;
  if (event.newValue && event.newValue != window.name) {
    window.location.href = window.location.origin + TAB_LOCK_ERROR_PATH;
  }
});

// Restored from bfcache ('load' does not fire again): take the lock back.
window.addEventListener("pageshow", (event) => {
  if (event.persisted) claimTabLock();
});

/**
   * 
   * @param {{force: boolean, reloadPage: boolean}} options 
   * force = true, do not check the cart count
   * reloadPage = true, reload the page after clearing the cart
   */
  async function clearCart({force = false, dontReloadPage = false} = {}) {
    debugTrace({action: 'zenda-clear-cart', message: 'Clear cart'});

    // Clear cart data
    try {

      let cartItemCount = 0;
      if (!force) {

        // Wait for 1 second to ensure cart is loaded
        await new Promise(resolve => setTimeout(resolve, 1e3));

        // Temp
        // const data = await fetch("/cart.json");
        const data = await fetch("/cart.js");
        let cart = await data.json();

        debugTrace({action: 'zenda-clear-cart', message: 'Fetched cart data', cart});

        if (cart && 'item_count' in cart)
          cartItemCount = cart.item_count;

        console.log('cartItemCount', cartItemCount);
      }

      // console.log("init cart", cart);

      // Check if cart has items. Note: Without checking the cart count, it infinitely reloads the page because we are reloading the page on the success response.
      if (cartItemCount > 0 || force) {
        fetch("/cart/clear.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          keepalive: true
        })
          .then((response) => response.json())
          .then((data) => {
            debugTrace({action: 'zenda-clear-cart-fn-clear.js-success', message: 'Zenda clear cart fn clear.js success', data});
            // Refresh the cart section or reload the page
            if (!dontReloadPage)
              location.reload(); // Refresh the page

            // console.log('clear-cart-response', data);
            document.documentElement.dispatchEvent(new CustomEvent('theme:cart:change', { 
              bubbles: !0, detail: { cartCount: data.item_count }
            }));
          })
          .catch((error) => {
            debugTrace({action: 'zenda-clear-cart-clear.js-error', message: 'Error clearing cart', error});
          });
      }
    } catch (error) {
      debugTrace({action: 'zenda-clear-cart-error', message: 'Error clearing cart', error});
    }
  }

/** Add Help Button to bottom of all pages */
(function addHelpButtonToAllPage() {

  // Create a new div wrapper element
  const wrapper = document.createElement('div');

  // Add styles to the wrapper div
  wrapper.style.position = 'fixed';
  wrapper.style.bottom = '30px';
  wrapper.style.right = '20px';
  wrapper.style.display = 'flex';
  wrapper.style.flexDirection = 'column';
  wrapper.style.alignItems = 'center';

  // Create a new div element
  const icon = document.createElement('div');

  // Add styles to the icon div
  icon.style.width = '40px';
  icon.style.height = '40px';
  icon.style.display = 'flex';
  icon.style.cursor = 'pointer';
  icon.style.background = 'white';
  
  // Add a class to the div
  icon.className = 'get-help-url';
  
  // Define the SVG icon as an innerHTML
  icon.innerHTML = `
    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="40" x="0" y="0" viewBox="0 0 24 24" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="m17.507 14.307-.009.075c-2.199-1.096-2.429-1.242-2.713-.816-.197.295-.771.964-.944 1.162-.175.195-.349.21-.646.075-.3-.15-1.263-.465-2.403-1.485-.888-.795-1.484-1.77-1.66-2.07-.293-.506.32-.578.878-1.634.1-.21.049-.375-.025-.524-.075-.15-.672-1.62-.922-2.206-.24-.584-.487-.51-.672-.51-.576-.05-.997-.042-1.368.344-1.614 1.774-1.207 3.604.174 5.55 2.714 3.552 4.16 4.206 6.804 5.114.714.227 1.365.195 1.88.121.574-.091 1.767-.721 2.016-1.426.255-.705.255-1.29.18-1.425-.074-.135-.27-.21-.57-.345z" fill="#9543ff" opacity="1" data-original="#000000" class=""></path><path d="M20.52 3.449C12.831-3.984.106 1.407.101 11.893c0 2.096.549 4.14 1.595 5.945L0 24l6.335-1.652c7.905 4.27 17.661-1.4 17.665-10.449 0-3.176-1.24-6.165-3.495-8.411zm1.482 8.417c-.006 7.633-8.385 12.4-15.012 8.504l-.36-.214-3.75.975 1.005-3.645-.239-.375c-4.124-6.565.614-15.145 8.426-15.145a9.865 9.865 0 0 1 7.021 2.91 9.788 9.788 0 0 1 2.909 6.99z" fill="#9543ff" opacity="1" data-original="#000000" class=""></path></g></svg>
  `;

  // Create label
  const label = document.createElement('label');
  label.style.marginTop = '10px';
  label.style.fontSize = '14px';
  label.style.color = 'black';
  label.innerHTML = '<strong>zenda help</strong>';
  label.style.display = 'none';
  
  // Append the icon and label to the wrapper
  wrapper.appendChild(icon);
  wrapper.appendChild(label);
  
  // Append the div to the body
  document.body.appendChild(wrapper);
  
  // Detect navigation to external URL - get help
  
  document.querySelectorAll(".get-help-url").forEach(function (link) {
    link.addEventListener("click", async _ => {

        debugTrace({action: 'zenda-get-help-url-listener', message: 'Zenda get help url listener added'});

        var messageObj = {ref: 'zendaOpen'};
        messageObj.history = window.location.href;
        messageObj.url = 'https://help.zenda.com';
        messageCaller(messageObj);
    });
  });
})();

function trackClicks(event) {
  const url = window.location.href;
  let eventMessage = '';
  if(event.currentTarget.innerText) eventMessage = event.currentTarget.innerText;
  else if(event.currentTarget.currentSrc) eventMessage = event.currentTarget.currentSrc;
  else eventMessage = event.className;
  
  var messageObj = {
    ref: 'datadog-events',
    event: 'click',
    url,
    eventMessage: eventMessage
  };
  console.log('Track click: ', {tagName: event?.target?.tagName, eventMessage});
  messageCaller(messageObj);
}

document.querySelectorAll('button').forEach(button => {
    button.addEventListener('click', trackClicks);
  });

  document.querySelectorAll('a').forEach(link => {
    link.addEventListener('click', trackClicks);
  });

  document.querySelectorAll('img').forEach(image => {
    image.addEventListener('click', trackClicks);
  });

document.addEventListener('DOMContentLoaded', function(){

  const url = window.location.href;
  // console.log(url);
  var messageObj = {
    ref: 'datadog-events',
    event: 'view',
    url
  };
  messageCaller(messageObj);

  document.querySelectorAll(".collection-list-outer").forEach(function (doc){
    let elemetsExists = false;
    doc.querySelectorAll(".collection-item").forEach(item => {
      if(window.getComputedStyle(item).display != "none") elemetsExists = true;
    })
    // console.log(elemetsExists);
    // console.log(document.querySelectorAll(".empty-collection-display-zenda"));
    document.querySelectorAll(".empty-collection-display-zenda").forEach(function (item) {
      console.log('cdn: ', !elemetsExists && item.getAttribute('data-ajax-loading') != 'true');
      if(!elemetsExists && item.getAttribute('data-ajax-loading') != 'true') {
        // console.log(elemetsExists);
        item.style.display = "block";  
      } else {
        item.style.display = "none";
      }
    });
    
  });
});

function onProductSubmit(event) {
  debugger
  event.preventDefault();

    // const validate = this._validateWkCustomOptionCheckbox();
    // if (!validate) return false;

    // return true;
    return false;
}

const productPage = {

  init: function() {
    this._forceCustomOpitonCheckboxRequired();
  },

  // Force any one of custom option checkbox to be required
  _forceCustomOpitonCheckboxRequired: () => {

    // Guard: Check the custom option checkbox present in the product page
    const container = document.querySelector('.wk_multiselect_cbx_container');
    if (!container) return;

    const checkboxes = Array.from(container.getElementsByTagName('input'));

    checkboxes.forEach(el => {
      el.required = true;
      el.addEventListener('change', () => {
          if (checkboxes.some(el => el.checked))
            checkboxes.forEach(eli => eli.required = el == eli);
          else checkboxes.forEach(eli => eli.required = true);
      });
    });
  }
};
productPage.init();

// const editCartFlow = localStorage.getItem('editCartFlow');
// window.addEventListener("beforeunload", function (e) {
//   // if(editCartFlow == 'true' && !messageTriggeredClose){
//   //   const confirmationMessage = "You have unsaved changes. Are you sure you want to leave?";

//   //   // Prevent default behavior and show confirmation dialog
//   //   e.preventDefault(); // Required by modern browsers
//   //   e.returnValue = confirmationMessage; // Required by modern browsers

//   //   return confirmationMessage;
//   // }
//   messageTriggeredClose = false;
//   if(false) return;
//   else {
//     e.preventDefault();
//     e.returnValue = 'return value'
//     return "return statement";
//   }
// });

// document.querySelectorAll("a").forEach(function(link) {
//   link.addEventListener("click", function(event) {
//     const href = event.target.getAttribute("href");

//     // Check if the link is internal (same origin)
//     if (href && href.startsWith("/") || href.includes(window.location.hostname)) {
//       messageTriggeredClose = true; // Mark as internal navigation
//     }
//   });
// });

// Uploadkit validations fix 
window.UploadKit = window.UploadKit || {};
window.UploadKit.cloneATCButton = true;

// Zenda ZIP-5283: keep `uploadkit-invalid` on the form until EVERY required uploader has a ready file.
// UploadKit re-validates per uploader (refreshUploader -> refreshFormRequiredValidation(<that uploader>)),
// so uploading to one of several required uploaders removed the class for the whole form.
// Its onFormValid callback fires right after it removes the class; re-check the whole form there.
window.UploadKit.callbacks = window.UploadKit.callbacks || {};
window.UploadKit.callbacks.onFormValid = function (form) {
  try {
    if (form && typeof window.UploadKit.containerInvalidUploaders === 'function' && window.UploadKit.containerInvalidUploaders(form).length > 0) {
      form.classList.add('uploadkit-invalid');
    }
  } catch (e) {}
};


/**
 * Get first 250 products of collection using product filters by collection handle.
 * @param handle {string}
 * @param vendor {string}
 * @param tags {string[]}
 * @param _endCursor {string | null} Internal purpose only
 * @returns [error, collection] t
 */
function getProductsByCollection(handle, vendor, tags, _endCursor=null) {
  return new Promise(resolve => {
    /* // Query format
      query: `{
        collection(handle: "subcollection-universal-uniforms-accessories") {
          id, title, handle
          products(first: 250, after: ${_endCursor}, filters: [{productVendor: "Dev Store Vendor"}, {tag: "dummy group"}, {tag: "All Students"}]) {
            pageInfo { endCursor, hasNextPage }
            edges {
              node {
                id, handle, title, vendor, tags, availableForSale
              }
            }
          }
        }
      }`
    */
    const after = _endCursor ? `after: "${_endCursor}"` : '';
    const query = `{
      collection(handle: "${handle}") {
        id, title, handle
        products(first: 250, ${after}, filters: ${`[{productVendor: "${vendor}"}, ${tags.map(tag => `{tag: "${tag}"}`).join(',')}]`}) {
          pageInfo { endCursor, hasNextPage }
          edges {
            node {
              id, handle, title, vendor, tags, availableForSale
            }
          }
        }
      }
    }`;
    // console.log('GraphQL query: ', query);
    fetch("/api/2025-01/graphql.json", {
      method: "POST",
      headers: {
          "X-Shopify-Storefront-Access-Token": "6ca9add229d4e5d386731463f577f33a",
          "Content-Type": "application/json"
      },
      body: JSON.stringify({query})
    })
    .then(response => response.json())
    .then(res => res.hasOwnProperty('errors') ? resolve([res.errors, null]) : resolve([null, res.data.collection]))
    .catch(error => resolve([error, null]));
  });
}

/**
 * Get all products of collection using product filters by collection handle.
 * @param handle {string}
 * @param vendor {string}
 * @param tags {string[]}
 * @param endCursor {string | null}
 * @returns [error, collection]
 */
function getAllProductsByCollection(handle, vendor, tags) {
  return new Promise(async resolve => {

    let collection = null, pageInfo = {endCursor: null, hasNextPage: false};
    do {
      const [err, _collection] = await getProductsByCollection(handle, vendor, tags, pageInfo.endCursor);
      if (err) return resolve([err]);

      if (!collection) collection = _collection;
      else collection.products.edges.push(..._collection.products.edges);

      pageInfo = _collection.products.pageInfo;
    }
    while(pageInfo.hasNextPage);

    return resolve([null, collection]);
  });
}

/**
 * Get specific products of collection using product filters by collection handle.
 * @param handle {string}
 * @param vendor {string}
 * @param tags {string[]}
 * @param cbOptions {{first?: () => collection, all?: () => collection}} Callback options: The First callback calls when get the first set of products, The All callback calls when get all the of products.
 * @returns [void] Understand all the REST APIs are completed.
 */
function getSpecificProductsByCollection(handle, vendor, tags, cbOptions) {
  return new Promise(async resolve => {

    let collection = null, pageInfo = {endCursor: null, hasNextPage: false};
    do {
      const [err, _collection] = await getProductsByCollection(handle, vendor, tags, pageInfo.endCursor);

      // Guard
      if (err) {
        console.log('err', err);
        break;
      }
  
      // Send the result back to callback options
      if ('first' in cbOptions) {
        cbOptions.first(_collection);
        delete cbOptions['first'];
      }
  
      // Guard: Break the statement if the all callback is not present in the cbOptions callback
      if (!('all' in cbOptions)) {
        break;
      }
  
      if (!collection) collection = _collection;
      else collection.products.edges.push(..._collection.products.edges);
  
      pageInfo = _collection.products.pageInfo;
    }
    while(pageInfo.hasNextPage);
  
    // Send the result back to callback options
    if ('all' in cbOptions) {
      cbOptions.all(collection);
      delete cbOptions['all'];
    }

    return resolve();
  });
}

function displayTotalAmountWithWkProductCusOption(wkCusOptionAmount) {

  // Guard: Check the wkCusOptionAmount is a valid number
  if (isNaN(wkCusOptionAmount)) return;
  
  // Guard: Check the product price element is present
  const productPriceElement = document.querySelector('.product__price [data-product-price]');
  if (!productPriceElement) return;

  const productPrice = parseInt(productPriceElement.getAttribute('data-product-price'));
  const shopMoneyFormat = productPriceElement.getAttribute('data-shop-money-format');
  const shopCurrency = productPriceElement.getAttribute('data-shop-currency');

  // Guard: Check the product price, shop money format and shop currency are valid
  if (isNaN(productPrice) || !shopMoneyFormat || !shopCurrency) return;

  const noDecimalCurrencies = ['JPY', 'KRW', 'VND']; // From Shopify documentation, these currencies do not have decimal places.
  const rawPrice = productPrice; // From Shopify
  const currency = shopCurrency; // From Shopify

  const price = noDecimalCurrencies.includes(currency) ? rawPrice : rawPrice / 100;

  // Calculate the total amount
  // Note: The product price is in cents, so we divide it by 100 to get the dollar amount
  const totalAmount = price + wkCusOptionAmount;

  // Display the total amount in the product price element
  const priceStr = noDecimalCurrencies.includes(currency) ? totalAmount.toFixed(0) : totalAmount.toFixed(2);
  productPriceElement.innerHTML = shopMoneyFormat.replace('{{amount}}', priceStr);
}


/**
 * Debug trace function to send data to native app for debugging
 * @param {{action: string, message: string, [key: string]: any}} data The data to send to native app
 */
function debugTrace(data) {

  // console.log('debugTrace', data);

  // Append event type
  if (data && typeof data == 'object')
    data.event = 'debugTrace';

  const consoleData = {
    data: data,
    location: window.location.href,
    ref: "consoleData"
  };
  messageCaller(consoleData);
}

(function() {

  // Add IAB Heartbeat and log clickable element check after window load
  window.addEventListener("load", (event) => {

    /* **** IAB Heartbeat **** */
    setInterval(() => {
      console.log("Zenda IAB heartbeat");
      debugTrace({ action: 'zenda-iab-heartbeat', message: 'Zenda IAB Heartbeat' });
    }, 25e3);

    /* **** Log: Alert if clickable element is not found in the dom **** */

    // Guard: If location is not cart page then return
    if (!window.location.pathname.endsWith('/cart')) return;

    const querySelectorAllEls = [
      // elements used in cart page
      "button.cart__checkout", ".get-help-url"

      // non cart page elements
      // "a.cart__checkout", ".external-url", "#wk-esign-preview-doc"
    ];
    const querySelectorEls = ["a.header__logo__link"];

    querySelectorAllEls.forEach(selector => {
      const target = document.querySelectorAll(selector);
      if (!target || target.length == 0)
        debugTrace({ action: 'zenda-click-listener-error', message: 'Checkout button not found in the cart page', selector, target });
    });

    querySelectorEls.forEach(selector => {
      const target = document.querySelector(selector);
      if (!target)
        debugTrace({ action: 'zenda-click-listener-error', message: 'Checkout button not found in the cart page', selector, target });
    });
  });

  /**
   * Detects when the page becomes visible again after being hidden/suspended.
   * This sends a "wakeup" ping to the native app, which can be used
   * as a trigger to re-initialize any broken message listeners.
   */
  document.addEventListener('visibilitychange', function() {
    // Check if the page has become visible
    if (document.visibilityState === 'visible') {
      
      // console.log('ZENDA: Page is visible again, sending wakeup ping.');
      
      // // Send a special message to the native app
      // // This assumes your messageCaller function is globally available
      // // or defined within this scope.
      // if (typeof messageCaller === 'function') {
      //   messageCaller({ ref: 'zendaPageVisible' });
      // }

      debugTrace({ action: 'zenda-page-visible', message: 'Zenda page is visible again, sending wakeup ping.' });
      
      // Send a special message to the native app
      // This assumes your messageCaller function is globally available
      // or defined within this scope.
      if (typeof messageCaller === 'function') {
        debugTrace({ action: 'zenda-page-visible-function', message: 'Sent zendaPageVisible message to native app.' });
      }
    }
  });

})();